import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import constants from "../../core/constants";
import moment from "moment";

function sortByPickupTime(data) {
  if (!Array.isArray(data)) return;

  data.sort((a, b) => {
    const dateA = new Date(a._source.pick_up_time);
    const dateB = new Date(b._source.pick_up_time);

    return dateA - dateB;
  });

  return data;
}

class BookingsPageTransform {
  constructor(Authentication) {
    "ngInject";

    this.userId = Authentication.getValue("owner");
  }
  justify(data, rideId) {
    const format = (item) => {
      item = assign({ _id: item._id }, item._source);
      item.date = moment(item.date).format(constants.dateTimeFormat);
      item.price = item.receipt.paid / constants.currencyBy;
      item.priceNum = item.price;
      item.extra_paid /= constants.currencyBy;
      let currency = "";
      if (item.ride) {
        item.rideName = `${item.ride.route.name} ${moment(
          item.ride.date
        ).format(constants.dateTimeFormat)}`;
        if (item.ride.currency) {
          item.price = `${item.price} ${item.ride.currency}`;
          item.extra_paid = `${item.extra_paid} ${item.ride.currency}`;
          currency = item.ride.currency;
        }

        if (rideId !== item.ride._id && item.is_transferred) {
          item.status = "transferred";
        }
      } else if (item.dynamic_trip && item.dynamic_trip.route) {
        item.rideName = `${item.dynamic_trip.route.name}`;
        item.price = `${item.price} ${item.dynamic_trip.route.currency}`;
        item.extra_paid = `${item.extra_paid} ${item.dynamic_trip.route.currency}`;
        currency = item.dynamic_trip.route.currency;
      }

      item.extraPaidNum = item.extra_paid;
      if (item.user) {
        item.phone = item.user.phone;
        item.email = item.user.email;
      }

      if (
        item.commuter_package_subscription &&
        typeof item.receipt.commuter_package_discount === "number"
      ) {
        item.commuter_package_amount = `${
          item.receipt.commuter_package_discount / constants.currencyBy
        } ${currency}`;
      } else {
        item.commuter_package_amount = "No";
      }

      if (item.pick_up) {
        if (item.pick_up_time) {
          item.pick_up = `${item.pick_up.name} at ${moment(
            item.pick_up_time
          ).format(constants.timeFormat)}`;
        }
      }
      if (item.promised_pick_up_time) {
        item.promised_pick_up = moment(item.promised_pick_up_time).format(
          constants.timeFormat
        );
      }
      if (item.promised_drop_off_time) {
        item.promised_drop_off = moment(item.promised_drop_off_time).format(
          constants.timeFormat
        );
      }
      if (item.drop_off) {
        if (item.drop_off_time) {
          item.drop_off = `${item.drop_off.name} at ${moment(
            item.drop_off_time
          ).format(constants.timeFormat)}`;
        }
      }

      if (item.payment) {
        item.payment.name = item.payment.name
          ? item.payment.name.substr(item.payment.name.length - 4)
          : null;
      }
      if (!item.boarding_pass) {
        item.boarding_pass = item._id.slice(-2);
      }

      return item;
    };

    const inReview = data.filter(
      (item) =>
        item._source.status === "in_review" &&
        item._source.reviewer !== this.userId
    );
    const inReviewWithMe = data.filter(
      (item) =>
        item._source.status === "in_review" &&
        item._source.reviewer === this.userId
    );

    const pendingReview = data.filter(
      (item) => item._source.status === "pending_review"
    );
    const accepted = data.filter((item) => item._source.status === "accepted");
    const rejected = data.filter((item) => item._source.status === "rejected");

    const sortedData = [
      ...sortByPickupTime(inReviewWithMe),
      ...sortByPickupTime(inReview),
      ...sortByPickupTime(pendingReview),
      ...sortByPickupTime(rejected),
      ...sortByPickupTime(accepted),
    ];

    return map(format)(sortedData);
  }
}

export default BookingsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/bookings/pendingBookings.transforms.js